import Vue from 'vue';
import DOMPurify from 'dompurify';
Vue.use(DOMPurify);
Vue.directive('sani-html', (el, binding) => {
  el.innerHTML = DOMPurify.sanitize(binding.value);
});